/* eslint-disable jsx-a11y/alt-text */
/**
 * This component receives a remote property "count"; its only purpose here is to make an alteration to the img src URL
 * which will prompt React to rerender the component.
 *
 * The job sending the counter variable (misc/adapt.js) does it after using scp to transfer image files
 * from a remote server into the auxstatic folder.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Cell } from '../../base/styled';

import './Adapt.scss';

const Adapt = (props) => {

  const { counter: { data: { count = 0 } = {} } = {} } = props;

  return (
    <div className="dashboard">
      <Grid columns={2} className="Adapt">
	<Cell width={2}>
	  <h2>AdAPT Oregon/North Virginia</h2>
	</Cell>
        <Cell>
          <img src={`/auxstatic/adproxy_hosts_or.png?count=${count}`} />
        </Cell>
        <Cell>
          <img src={`/auxstatic/adproxy_hosts_nv.png?count=${count}`} />
        </Cell>
        <Cell>
          <img src={`/auxstatic/adproxy_requests_or.png?count=${count}`} />
        </Cell>
        <Cell>
          <img src={`/auxstatic/adproxy_requests_nv.png?count=${count}`} />
        </Cell>
        <Cell>
          <img src={`/auxstatic/adproxy_response_times_or.png?count=${count}`} />
        </Cell>
        <Cell>
          <img src={`/auxstatic/adproxy_response_times_nv.png?count=${count}`} />
        </Cell>
	<Cell>
	  <img src={`/auxstatic/mediaconvert_standby_time_or.png?count=${count}`} />
	</Cell>
	<Cell>
	  <img src={`/auxstatic/mediaconvert_standby_time_nv.png?count=${count}`} />
	</Cell>
      </Grid>
    </div>
  );
};

Adapt.propTypes = { counter: PropTypes.shape({ data: PropTypes.shape({ count: PropTypes.number }) }) };
Adapt.defaultProps = null;

export default Adapt;
